import ko from "knockout";
import dateHelper from "flow/utils/dateHelper";
import { MaybeObservable, MaybeObservableAttributes, ObservableAttributes } from "flow/interfaces/MaybeObservable";
import viewHtml from "./endDate.html";
import createRequiredObservable from "flow/koHelpers/createRequiredObservable";
import { selectIdStatic } from "flow/koHelpers/selectId";
import { selectLabel, selectPlaceholder } from "flow/koHelpers/selectParam";
import createEnabler from "flow/koHelpers/createEnablerDisabler";
import { interceptAttributesWithDefaultsIgnoreId } from "flow/koHelpers/interceptAttributes";
import metaCache from "flow/utils/metaCache";

export interface IEndDateParams {
    daysAfterStartDate?: number;
    enable?: MaybeObservable<boolean>;
    disable?: MaybeObservable<boolean>;
    enableMaxWidth?: boolean;
    startDate?: KnockoutObservable<string>;
    value: KnockoutObservable<string>;
    valueUpdate?: string;
    attr?: MaybeObservableAttributes;
    meta?: MaybeObservable<string>;
    text?: MaybeObservable<string>;
    metaPlaceholder?: MaybeObservable<string>;
    placeholder?: MaybeObservable<string>;
}

class EndDateViewModel {
    daysAfterStartDate: number;
    required: MaybeObservable<boolean>;
    enable: MaybeObservable<boolean>;
    enableMaxWidth: boolean;
    startDate: KnockoutObservable<string>;
    value: KnockoutObservable<string>;
    valueUpdate: string;
    attributes: ObservableAttributes;
    meta: MaybeObservable<string>;
    text: MaybeObservable<string>;
    id: string;
    label: KnockoutObservable<string>;
    ariaLabel: KnockoutComputed<string>;

    constructor(params: IEndDateParams, input: Element) {
        this.value = params.value;
        this.valueUpdate = params.valueUpdate;

        this.required = createRequiredObservable(params.value);

        this.id = selectIdStatic("ko_enddate", params.attr);

        this.label = selectLabel(params.meta, params.text);

        this.enable = createEnabler(params.enable, params.disable);

        this.startDate = params.startDate || ko.observable(dateHelper.toShortDate(new Date(0)));
        this.daysAfterStartDate = 1;
        this.enableMaxWidth = params.enableMaxWidth ? params.enableMaxWidth : false;

        if (typeof params.daysAfterStartDate === "number") {
            this.daysAfterStartDate = params.daysAfterStartDate;
        }

        this.attributes = interceptAttributesWithDefaultsIgnoreId(
            {
                autocomplete: "off",
                placeholder: selectPlaceholder(params.metaPlaceholder, params.placeholder)
            },
            params.attr
        );

        this.ariaLabel = ko.pureComputed(() => {
            return this.value()
                ? `${metaCache.translate("FlowHtml.Translations.ChangeDate")}, ${this.value()}`
                : `${metaCache.translate("FlowHtml.Translations.ChooseDate")}`;
        });

        input.setAttribute("id", this.id);
    }
}

ko.components.register("ko-enddate", {
    viewModel: {
        createViewModel(params: any, componentInfo: KnockoutComponentTypes.ComponentInfo) {
            const input = (componentInfo.element as HTMLElement).querySelector("input");
            return new EndDateViewModel(params, input);
        }
    },
    template: viewHtml,
    synchronous: true
});
